GW.override(GW.Application, {
	'after:activateCard'(c) {
		/* 
		 * Add a class to <html> if the selected card has native design
		 * for desktop style. Otherwise CSS will apply narrow mobile
		 * style emulation.
		 */
		document.documentElement.classList.toggle('native-desktop', !!c.nativeDesktop);
	},

	'after:initComponent'() {
		document.documentElement.classList.toggle('scrolled-to-top', document.scrollingElement.scrollTop == 0);
		document.addEventListener('scroll', ev => {
			document.documentElement.classList.toggle('scrolled-to-top', document.scrollingElement.scrollTop == 0);
		}, {passive: true});
	},
});

Element.prototype.gwHide = function(v) {
	this.classList.toggle('hidden', !!v);
};
